import React, { useState } from "react";
import "./Modal.css";
import config from "../../config";

import { CircularProgress } from "@material-ui/core";

// styles
import useStyles from "../login/styles";

const ModalMembershipType = ({ isOpen, closeModal, partnerId, onFinish, isPendding, origin, newMembership, membershipId, oldCost, newCost, differrence, partnerStatus }) => {
    var classes = useStyles();
    const handleContainerClick = (e) => e.stopPropagation();
    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [isLoading, setIsLoading] = useState(false);

    const onYesButton = async e => {
        e.preventDefault();
        setIsLoading(true);

        const body = {
            partnerId: partnerId, principalPartnerId: membershipId
        };

        const response = await fetch(baseUrl + "changeMembershipType", {
            method: 'POST',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
            body: JSON.stringify(body)
        });

        const json = await response.json();
        if (json.message == "Ok") {
            setIsLoading(false);
            onFinish("Ok");
            closeModal();
        } else {
            setIsLoading(false);
            onFinish("Error");
            closeModal();
        }
    }

    const onNoButton = async e => {
        e.preventDefault();
        closeModal();
    }

    function currencyFormat(num) {
        return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    return <article className={`modal ${isOpen && "is-open"}`}
        onClick={closeModal}>
        <div className="modal-group" onClick={handleContainerClick}>
            <div>
                <p style={{ fontSize: "20px", textAlign: "center" }}>{"Cambiando de " + origin + " a " + newMembership}</p>
                <p style={{ fontSize: "16px" }}>{"Costo anterior: " + currencyFormat(Number(oldCost))}</p>
                <p style={{ fontSize: "16px" }}>{"Nuevo costo: " + currencyFormat(Number(newCost))}</p>

                {partnerStatus === "Activo" ? (
                    <>
                        {isPendding ? (
                            <>
                                <p style={{ fontSize: "16px" }}>{"Diferencia: " + currencyFormat(Number(differrence))}</p>
                                <p style={{ fontSize: "16px", textAlign: "center" }}>Al realilzar este cambio el socio permanecerá suspendido hasta completar su pago.</p>
                            </>
                        ) : (
                            <>
                                <p style={{ fontSize: "16px", textAlign: "center" }}>Al realilzar este cambio el socio no recibirá devoluciones de efectivo y mantiene el estatus actual.</p>
                            </>
                        )}
                    </>
                ) : (
                    <div style={{ height: "70px" }}></div>
                )}

                <p style={{ fontSize: "16px", textAlign: "center" }}>¿Deseas continuar con el cambio?</p>

                {isLoading ? (
                    <div className={classes.loginLoader} style={{ margin: "auto", textAlign: "center" }}>
                        <CircularProgress size={26} />
                    </div>
                ) : (
                    <div className={classes.rowButtons}>
                        <button
                            className={classes.buttonYes}
                            onClick={onYesButton}
                        >SI</button>

                        <button
                            className={classes.buttonNo}
                            onClick={onNoButton}
                        >NO</button>
                    </div>
                )}
            </div>
        </div>
    </article>
}

export default ModalMembershipType;